// src/pages/tenant/ThankYou.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function ThankYou() {
  const navigate = useNavigate();

  return (
    <Box
      height="80vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <CheckCircleIcon sx={{ fontSize: 80, color: 'green', mb: 2 }} />
      <Typography variant="h5" mb={2}>
        Thank you! Your payment was received.
      </Typography>
      <Button variant="contained" color="success" onClick={() => navigate('/tenant')}>
        Return to Dashboard
      </Button>
    </Box>
  );
}